import globals from '../../api/Globals'

// initial state
const state = {
  globals: {auth: 0},
  menuActive: false,
  messages: [],
  loginResponse: false,
  translation: {},
  langInitialized: false,
  modalAlert: false,
  resetPasswordResponse: {},
  resetPasswordSubmitResponse: {}
}

// getters
const getters = {
  globals: state => state.globals,
  menuActive: state => state.menuActive,
  messages: state => state.messages,
  loginResponse: state => state.loginResponse,
  translation: state => state.translation,
  langInitialized: state => state.langInitialized,
  modalAlert: state => state.modalAlert,
  resetPasswordResponse: state => state.resetPasswordResponse,
  resetPasswordSubmitResponse: state => state.resetPasswordSubmitResponse
}

// actions
const actions = {
  getGlobals ({ commit }) {
    globals.getGlobals(globals => {
      commit('RECEIVE_GLOBALS', { globals })
    })
  },
  fetchLanguage: function (context, data) {
    globals.fetchLanguage(data, translation => {
      context.commit('RECEIVE_LANGUAGE', { translation })
    })
  },
  login: function (context, data) {
    globals.login(data, loginResponse => {
      context.commit('LOGIN_RESPONSE', { loginResponse })
      globals.getGlobals(globals => {
        context.commit('RECEIVE_GLOBALS', { globals })
      })
    })
  },
  logout ({ commit }) {
    globals.logout(function(context)
    {
      globals.getGlobals(globals => {
        commit('RECEIVE_GLOBALS', { globals })
      })
    })
  },
  requestResetPassword: function (context, data) {
    return new Promise((resolve) => {
      globals.requestResetPassword(data, response => {
        context.commit('RESET_PASSWORD_RESPONSE', { response })
        resolve(response)
      })
    })
  },
  resetPassword: function (context, data) {
    return new Promise((resolve) => {
      globals.resetPassword(data, response => {
        context.commit('RESET_PASSWORD_SUBMIT_RESPONSE', { response })
        resolve(response)
      })
    })
  }
}

// mutations
const mutations = {
  ['RECEIVE_GLOBALS'] (state, { globals }) {
    state.globals = globals
  },
  ['RECEIVE_LANGUAGE'] (state, { translation }) {
    state.langInitialized = true;
    state.translation = translation
  },
  ['LOGIN_RESPONSE'] (state, { loginResponse }) {
    state.loginResponse = loginResponse
  },
  ['RESET_PASSWORD_RESPONSE'] (state, { response }) {
    state.resetPasswordResponse = response
  },
  ['RESET_PASSWORD_SUBMIT_RESPONSE'] (state, { response }) {
    state.resetPasswordSubmitResponse = response
  },
  setModalAlert: function(state, modalAlert) {
    state.modalAlert = modalAlert
  },
  toggleMenu: state => state.menuActive = !state.menuActive
}

export default {
  state,
  getters,
  actions,
  mutations
}
